import { render } from "./HomeTableMobile.vue?vue&type=template&id=2797a5af&scoped=true"
import script from "./HomeTableMobile.vue?vue&type=script&lang=js"
export * from "./HomeTableMobile.vue?vue&type=script&lang=js"

import "./HomeTableMobile.vue?vue&type=style&index=0&id=2797a5af&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2797a5af"]])

export default __exports__